/**
 * Control Center access composable.
 *
 * Determines whether the current user can see and access the
 * Control Center nav section based on their role.
 */

// Known role IDs that always have access
const ALLOWED_ROLE_IDS = [2, 4, 5, 6] // RB Admin User, dev, Extended User, RB Admin User (legacy)

// Role names with access (Extended User ID is dynamic)
const ALLOWED_ROLE_NAMES = ['dev', 'Extended User', 'RB Admin User']

/**
 * Check if a given role can access the Control Center.
 *
 * @param {number|null} roleId
 * @param {string|null} roleName
 * @returns {boolean}
 */
export function canAccessControlCenter(roleId, roleName) {
  return Boolean(
    (roleId && ALLOWED_ROLE_IDS.includes(roleId))
    || (roleName && ALLOWED_ROLE_NAMES.includes(roleName)),
  )
}

/**
 * Synchronous getter for nav filtering / route guards.
 * Reads from localStorage (same pattern as getAdminStatusSync).
 *
 * @returns {{ hasAccess: boolean }}
 */
export function getControlCenterAccessSync() {
  try {
    const raw = localStorage.getItem('userData')
    if (!raw || raw === 'undefined') return { hasAccess: false }

    const user = JSON.parse(raw)
    const roleId = user?.role?.id ?? null
    const roleName = user?.role?.name ?? null

    return { hasAccess: canAccessControlCenter(roleId, roleName) }
  } catch {
    return { hasAccess: false }
  }
}
